/* eslint-disable-next-line */
const easeInOutQuad = (t, b, c, d) => c * (t /= d) * t + b;

/**
 * Minimal use: horizontalScroll(container, {})
 */
const horizontalScroll = (container, { increment = 20, duration = 300, invert = false }) => {
    if (typeof container === 'undefined' || container === null) {
        return;
    }

    const child = container.childNodes[0];
    const childStyles = window.getComputedStyle(child);
    const childWidth = child.offsetWidth + parseFloat(childStyles.marginLeft) + parseFloat(childStyles.marginRight);
    const childrenInView = Math.floor(container.offsetWidth / childWidth);
    const scrollLength = childWidth * childrenInView;

    const distance = invert === true ? -Math.abs(scrollLength) : scrollLength;

    const startingPosition = container.scrollLeft;
    let currentTime = 0;

    const animateScroll = () => {
        currentTime += increment;
        const val = easeInOutQuad(currentTime, startingPosition, distance, duration);

        container.scrollLeft = val;

        if (currentTime < duration) {
            setTimeout(animateScroll, increment);
        }
    };

    animateScroll();
};

export default horizontalScroll;
